import moment from 'moment'

export const NOW = 'NOW'

export const THREE_MONTHS_BEFORE_START = 'THREE_MONTHS_BEFORE_START'
export const TWO_MONTHS_BEFORE_START = 'TWO_MONTHS_BEFORE_START'
export const ONE_MONTH_BEFORE_START = 'ONE_MONTH_BEFORE_START'
export const FOUR_WEEKS_BEFORE_START = 'FOUR_WEEKS_BEFORE_START'
export const THREE_WEEKS_BEFORE_START = 'THREE_WEEKS_BEFORE_START'
export const TWO_WEEKS_BEFORE_START = 'TWO_WEEKS_BEFORE_START'
export const ONE_WEEK_BEFORE_START = 'ONE_WEEK_BEFORE_START'
export const FIVE_DAYS_BEFORE_START = 'FIVE_DAYS_BEFORE_START'
export const FOUR_DAYS_BEFORE_START = 'FOUR_DAYS_BEFORE_START'
export const THREE_DAYS_BEFORE_START = 'THREE_DAYS_BEFORE_START'
export const TWO_DAYS_BEFORE_START = 'TWO_DAYS_BEFORE_START'
export const ONE_DAY_BEFORE_START = 'ONE_DAY_BEFORE_START'
export const EVENING_BEFORE_START = 'EVENING_BEFORE_START'
export const MORNING_OF_START = 'MORNING_OF_START'
export const START = 'START'

export const THREE_MONTHS_BEFORE_END = 'THREE_MONTHS_BEFORE_END'
export const TWO_MONTHS_BEFORE_END = 'TWO_MONTHS_BEFORE_END'
export const ONE_MONTH_BEFORE_END = 'ONE_MONTH_BEFORE_END'
export const FOUR_WEEKS_BEFORE_END = 'FOUR_WEEKS_BEFORE_END'
export const THREE_WEEKS_BEFORE_END = 'THREE_WEEKS_BEFORE_END'
export const TWO_WEEKS_BEFORE_END = 'TWO_WEEKS_BEFORE_END'
export const ONE_WEEK_BEFORE_END = 'ONE_WEEK_BEFORE_END'
export const FIVE_DAYS_BEFORE_END = 'FIVE_DAYS_BEFORE_END'
export const FOUR_DAYS_BEFORE_END = 'FOUR_DAYS_BEFORE_END'
export const THREE_DAYS_BEFORE_END = 'THREE_DAYS_BEFORE_END'
export const TWO_DAYS_BEFORE_END = 'TWO_DAYS_BEFORE_END'
export const ONE_DAY_BEFORE_END = 'ONE_DAY_BEFORE_END'
export const EVENING_BEFORE_END = 'EVENING_BEFORE_END'
export const MORNING_OF_END = 'MORNING_OF_END'
export const END = 'END'

export const relativeDateOptions = [
  { value: NOW, text: 'Now', compute: () => moment(Date.now()) },
  {
    value: THREE_MONTHS_BEFORE_START,
    text: 'Three months before the start of the event',
    compute: (start, end) => moment(start).subtract(3, 'months')
  },
  {
    value: TWO_MONTHS_BEFORE_START,
    text: 'Two months before the start of the event',
    compute: (start, end) => moment(start).subtract(2, 'months')
  },
  {
    value: ONE_MONTH_BEFORE_START,
    text: 'One month before the start of the event',
    compute: (start, end) => moment(start).subtract(1, 'month')
  },
  {
    value: FOUR_WEEKS_BEFORE_START,
    text: 'Four weeks before the start of the event',
    compute: (start, end) => moment(start).subtract(4, 'weeks')
  },
  {
    value: THREE_WEEKS_BEFORE_START,
    text: 'Three weeks before the start of the event',
    compute: (start, end) => moment(start).subtract(3, 'weeks')
  },
  {
    value: TWO_WEEKS_BEFORE_START,
    text: 'Two weeks before the start of the event',
    compute: (start, end) => moment(start).subtract(2, 'weeks')
  },
  {
    value: ONE_WEEK_BEFORE_START,
    text: 'One week before the start of the event',
    compute: (start, end) => moment(start).subtract(1, 'week')
  },
  {
    value: FIVE_DAYS_BEFORE_START,
    text: 'Five days before the start of the event',
    compute: (start, end) => moment(start).subtract(5, 'days')
  },
  {
    value: FOUR_DAYS_BEFORE_START,
    text: 'Four days before the start of the event',
    compute: (start, end) => moment(start).subtract(4, 'days')
  },
  {
    value: THREE_DAYS_BEFORE_START,
    text: 'Three days before the start of the event',
    compute: (start, end) => moment(start).subtract(3, 'days')
  },
  {
    value: TWO_DAYS_BEFORE_START,
    text: 'Two days before the start of the event',
    compute: (start, end) => moment(start).subtract(2, 'days')
  },
  {
    value: ONE_DAY_BEFORE_START,
    text: 'One day before the start of the event',
    compute: (start, end) => moment(start).subtract(1, 'day')
  },
  {
    value: EVENING_BEFORE_START,
    text: 'The evening before the start of the event',
    compute: (start, end) =>
      moment(start)
        .subtract(1, 'day')
        .hours(21)
        .minutes(0)
        .seconds(0)
  },
  {
    value: MORNING_OF_START,
    text: 'The morning of the day the event starts',
    compute: (start, end) =>
      moment(start)
        .hours(9)
        .minutes(0)
        .seconds(0)
  },
  {
    value: START,
    text: 'The start of the event',
    compute: (start, end) => moment(start)
  },
  {
    value: THREE_MONTHS_BEFORE_END,
    text: 'Three months before the end of the event',
    compute: (start, end) => moment(end).subtract(3, 'months')
  },
  {
    value: TWO_MONTHS_BEFORE_END,
    text: 'Two months before the end of the event',
    compute: (start, end) => moment(end).subtract(2, 'months')
  },
  {
    value: ONE_MONTH_BEFORE_END,
    text: 'One month before the end of the event',
    compute: (start, end) => moment(end).subtract(1, 'month')
  },
  {
    value: FOUR_WEEKS_BEFORE_END,
    text: 'Four weeks before the end of the event',
    compute: (start, end) => moment(end).subtract(4, 'weeks')
  },
  {
    value: THREE_WEEKS_BEFORE_END,
    text: 'Three weeks before the end of the event',
    compute: (start, end) => moment(end).subtract(3, 'weeks')
  },
  {
    value: TWO_WEEKS_BEFORE_END,
    text: 'Two weeks before the end of the event',
    compute: (start, end) => moment(end).subtract(2, 'weeks')
  },
  {
    value: ONE_WEEK_BEFORE_END,
    text: 'One week before the end of the event',
    compute: (start, end) => moment(end).subtract(1, 'week')
  },
  {
    value: FIVE_DAYS_BEFORE_END,
    text: 'Five days before the end of the event',
    compute: (start, end) => moment(end).subtract(5, 'days')
  },
  {
    value: FOUR_DAYS_BEFORE_END,
    text: 'Four days before the end of the event',
    compute: (start, end) => moment(end).subtract(4, 'days')
  },
  {
    value: THREE_DAYS_BEFORE_END,
    text: 'Three days before the end of the event',
    compute: (start, end) => moment(end).subtract(3, 'days')
  },
  {
    value: TWO_DAYS_BEFORE_END,
    text: 'Two days before the end of the event',
    compute: (start, end) => moment(end).subtract(2, 'days')
  },
  {
    value: ONE_DAY_BEFORE_END,
    text: 'One day before the end of the event',
    compute: (start, end) => moment(end).subtract(1, 'day')
  },
  {
    value: EVENING_BEFORE_END,
    text: 'The evening before the end of the event',
    compute: (start, end) =>
      moment(end)
        .subtract(1, 'day')
        .hours(21)
        .minutes(0)
        .seconds(0)
  },
  {
    value: MORNING_OF_END,
    text: 'The morning of the end of the event',
    compute: (start, end) =>
      moment(end)
        .hours(9)
        .minutes(0)
        .seconds(0)
  },
  { value: END, text: 'The end of the event', compute: (start, end) => moment(end) }
]

export const relativeDateValues = relativeDateOptions.map(({ value }) => value)

export const computeRelativeDate = (start, end, selectedOption) => {
  const selected = relativeDateOptions.find(({ value }) => value === selectedOption)
  return selected ? selected.compute(start, end).unix() : undefined
}
